module.exports = __webpack_public_path__ + "static/media/instagram_logo.b6187251.svg";